





















import Vue, { VNode } from 'vue';
import { CSSStyleOptions } from '../common-types';
import { SwExtendedVue } from '../sw-extended-vue';
import { utilService } from '../util-service';

const cssPrefix = 'sw-icon';

const minimalFontSize = 12;

export default Vue.extend({
  functional: true,
  props: {
    name: { type: String, required: true },
    size: { type: [String, Number], default: 'medium' },
    color: { type: String },
    bottomAlign: { type: Boolean, default: false },
    rotate: { type: Number, default: 0 },
    asBlock: { type: Boolean, default: false },
  },
  /* tslint:disable-next-line */
  render(h, context) {
    const numericSize = (() => {
      if (typeof context.props.size === 'number') {
        return context.props.size;
      }
      return utilService.sizeMap[context.props.size] || utilService.sizeMap['medium'];
    })();
    const internalRotate = context.props.rotate !== undefined ? `rotate(${context.props.rotate}deg)` : '';
    const styles: CSSStyleOptions = {
      width: `${numericSize}px`,
      height: `${numericSize}px`,
      transform: `${internalRotate}`,
      color: context.props.color || undefined,
    };
    const innerStyles = (() => {
      const effectiveFontSize = Math.max(minimalFontSize, numericSize);
      let scale = '';

      const style: CSSStyleOptions = {
        fontSize: `${effectiveFontSize}px`,
      };

      if (effectiveFontSize !== numericSize) {
        scale = `scale(${numericSize / effectiveFontSize})`;
        style.transform = scale;
        style.width = `${effectiveFontSize}px`;
        style.height = `${effectiveFontSize}px`;
        style.left = `${(numericSize - effectiveFontSize) / 2}px`;
        style.top = `${(numericSize - effectiveFontSize) / 2}px`;
      }

      return style;
    })();

    const data = utilService.extractFunctionalCompRootNodeData(context.data);

    return (
      <span
        class={[`${cssPrefix}`,
          {
            [`${cssPrefix}--bottom`]: context.props.bottomAlign,
            [`${cssPrefix}--block`]: context.props.asBlock,
          },
        ]}
        style={styles}
        { ...data }
      >
        <span class={[`${cssPrefix}__inner`, 'sw-font-icon', `icon-${context.props.name}`]} style={innerStyles}></span>
      </span>
    ) as VNode;
  },
}) as typeof SwExtendedVue;
